import { useState } from 'react';
import { Image as ImageIcon } from '@phosphor-icons/react';

interface Props {
  src?: string;
  alt: string;
  caption?: string;
}

/**
 * A framed image placeholder for guide screenshots. If src is missing or fails
 * to load, it renders a styled placeholder tile so screenshots can be added
 * incrementally without breaking the guide layout.
 */
export function GuideScreenshot({ src, alt, caption }: Props) {
  const [errored, setErrored] = useState(false);
  const show = Boolean(src) && !errored;

  return (
    <figure className="glass-panel overflow-hidden">
      <div className="aspect-[16/9] w-full bg-black/20">
        {show ? (
          <img
            src={src}
            alt={alt}
            loading="lazy"
            onError={() => setErrored(true)}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full flex-col items-center justify-center gap-2 text-muted-foreground">
            <ImageIcon className="h-6 w-6" />
            <p className="text-xs uppercase tracking-widest">Screenshot coming soon</p>
            <p className="px-6 text-center text-xs text-muted-foreground/70">{alt}</p>
          </div>
        )}
      </div>
      {caption && (
        <figcaption className="border-t border-white/5 px-4 py-3 text-xs text-muted-foreground">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
